import { Injectable } from '@angular/core';
import { PostmethodService } from '../../app-config/postmethod.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationListDetailsService {

  constructor(private ws: PostmethodService) { }
  private data = new BehaviorSubject<any>('');
  currentData: any = this.data.asObservable();
  changeData(newData: any) {
    this.data.next(newData);
  }

  getToDoList(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "/lead/todoList");
  }
}
